const IconAi = ({ className }) => {
    return (
        <svg
            width='44'
            height='38'
            viewBox='0 0 68 63'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path
                id='Vector'
                d='M39.14 16.22L40.12 19.52C42 25.5 46.69 30.18 52.67 32.07L57.47 33.58L52.67 35.09C46.69 36.97 42.01 41.66 40.12 47.64L38.61 52.44L37.1 47.64C35.22 41.66 30.53 36.98 24.55 35.09L19.75 33.58L24.41 32.11C30.48 30.2 35.24 25.44 37.15 19.37L38.62 14.71L39.14 16.22Z'
                strokeWidth='6'
                strokeMiterlimit='10'
            />
            <path
                id='Vector_2'
                d='M13.28 4.3999L14.21 6.9499C15.12 9.4599 17.1 11.4399 19.61 12.3499L22.16 13.2799L19.61 14.2099C17.1 15.1199 15.12 17.0999 14.21 19.6099L13.28 22.1599L12.35 19.6099C11.44 17.0999 9.46002 15.1199 6.95002 14.2099L4.40002 13.2799L6.89002 12.3799C9.44002 11.4499 11.45 9.4399 12.38 6.8899L13.28 4.3999Z'
                strokeWidth='3'
                strokeMiterlimit='10'
            />
            <path
                id='Vector_3'
                d='M18.22 46.4297L19.16 48.2897C19.66 49.2897 20.47 50.0997 21.47 50.5997L23.33 51.5397L21.47 52.4797C20.47 52.9797 19.66 53.7897 19.16 54.7897L18.22 56.6497L17.28 54.7897C16.78 53.7897 15.97 52.9797 14.97 52.4797L13.11 51.5397L14.95 50.6197C15.96 50.1097 16.79 49.2897 17.3 48.2697L18.22 46.4297Z'
                strokeWidth='3'
                strokeMiterlimit='10'
            />
        </svg>
    );
};

export default IconAi;
